export const iconFontAwesomeMoneyKipSign = (
	<i className="fa-solid fa-kip-sign"></i>
);
